import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=3108753e&"
import script from "./BaseBadge.vue?vue&type=script&lang=js&"
export * from "./BaseBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3108753e')) {
      api.createRecord('3108753e', component.options)
    } else {
      api.reload('3108753e', component.options)
    }
    module.hot.accept("./BaseBadge.vue?vue&type=template&id=3108753e&", function () {
      api.rerender('3108753e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/BaseBadge.vue"
export default component.exports